export const AUCTION_INSIGHT_COLUMN_METRICS = {
  ImpressionShare: 'ImpressionShare',
  TopOfPageRate: 'TopOfPageRate',
  AbsoluteTopOfPageRate: 'AbsoluteTopOfPageRate',
  AboveRate: 'AboveRate',
  OverlapRate: 'OverlapRate',
  OutrankingShare: 'OutrankingShare',
  AveragePosition: 'AveragePosition',
  SegmentedData: 'SegmentedData',
};

export const DEVICE_SEGMENT_TYPES = {
  Computer: 'PC',
  SmartPhone: 'SmartPhone',
  Tablet: 'Tablet',
};

export const MAX_NUMBER_OF_ACCOUNT = 300;
export const MAX_ACCOUNTS_LIMIT_MT = 3000;
export const TOO_MUCH_DATA_TO_DOWNLOAD_ERROR = 'TooMuchDataToDownload';
